import { computed, DestroyRef, inject, Injectable, signal } from '@angular/core';
import { BadgeColor } from '@circlek-global/lds-components';

import type { OpeningHours } from '~models/station.model';
import { TranslationService } from '~services/translation.service';
import { getStationStatus, StationStatus } from '~utils/station-status.utils';

const STATUS_UPDATE_INTERVAL_MS = 60_000;

@Injectable()
export class StationStatusService {
  readonly openingHours = signal<OpeningHours | undefined>(undefined);
  readonly status = computed((): StationStatus => {
    this.currentTime();

    return getStationStatus(this.openingHours());
  });
  readonly statusBadgeColor = computed(() => {
    switch (this.status()) {
      case StationStatus.OPEN:
        return BadgeColor.SUCCESS;
      case StationStatus.CLOSES_SOON:
        return BadgeColor.WARNING;
      default:
        return BadgeColor.ERROR;
    }
  });
  readonly statusLabel = computed(() => {
    this.translationService.getLanguage();

    switch (this.status()) {
      case StationStatus.OPEN:
        return this.translationService.translate('openNow');
      case StationStatus.CLOSES_SOON:
        return this.translationService.translate('closesSoon');
      default:
        return this.translationService.translate('closed');
    }
  });
  private readonly translationService = inject(TranslationService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly currentTime = signal(new Date());

  constructor() {
    const updateInterval = setInterval(() => {
      this.currentTime.set(new Date());
    }, STATUS_UPDATE_INTERVAL_MS);

    this.destroyRef.onDestroy(() => clearInterval(updateInterval));
  }
}
